import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { number, shape, string } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import { withViewport } from '../../util/contextHelpers';
import { propTypes } from '../../util/types';
import { ensureCurrentUser } from '../../util/data';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '../../containers';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  AccountView,
} from '../../components';

import PersonalInfosTab from './components/PersonalInfosTab/PersonalInfosTab';
import css from './AccountPersonalInfosPage.module.css';

const MOBILE_MAX_WIDTH = 767;

const AccountPersonalInfosPage = (props) => {
  const {
    currentTab,
    currentUser,
    scrollingDisabled,
    viewport,
    intl,
  } = props;
  const ensuredCurrentUser = ensureCurrentUser(currentUser);
  const tabs = {
    'PersonalInfos': {
      tabName: 'PersonalInfos',
      routeName: 'AccountPersonalInfosPage',
      title: intl.formatMessage({ id: 'AccountPersonalInfosPage.personalInfosTabTitle' }),
      component: <PersonalInfosTab currentUser={ensuredCurrentUser} />,
      tipTitle: intl.formatMessage({ id: 'AccountPersonalInfosPage.personalInfosTabTipTitle' }),
      tip: intl.formatMessage({ id: 'AccountPersonalInfosPage.personalInfosTabTip' }),
    },
  };
  const pageTitle = intl.formatMessage({ id: 'AccountPersonalInfosPage.pageTitle' });
  const viewTitle = intl.formatMessage({ id: 'AccountPersonalInfosPage.viewTitle' });
  const isMobile = viewport.width <= MOBILE_MAX_WIDTH;
  
  return (
    <Page title={pageTitle} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="AccountPersonalInfosPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain className={css.layoutWrapperMain}>
          <AccountView
            title={viewTitle}
            tabs={tabs}
            currentTab={currentTab}
            withoutNav
            intl={intl}
          />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          {!isMobile && (
            <Footer />
          )}
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  )
};

AccountPersonalInfosPage.defaultProps = {
};

AccountPersonalInfosPage.propTypes = {
  currentTab: string.isRequired,
  currentUser: propTypes.currentUser,
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

export default compose(connect(mapStateToProps), withViewport, injectIntl)(AccountPersonalInfosPage);
